import { render, staticRenderFns } from "./Anfahrt.vue?vue&type=template&id=4ce689a4&align--center=true&text--center=true&"
import script from "./Anfahrt.vue?vue&type=script&lang=js&"
export * from "./Anfahrt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports